import BaseModelRequest from "./base/BaseModelRequest";

export default class OrderRequest extends BaseModelRequest {
  getModelName() {
    return "orders";
  }

  cancel(id) {
    let url = "/orders/" + id + "/cancel";
    return this.put(url);
  }

  cancelOrder(body) {
    let url = "/spot-order/cancel-order";
    return this.post(url, body);
  }

  cancelAll(body) {
    let url = "/spot-order/cancel-all";
    return this.post(url, body);
  }

  cancelByType(params) {
    let url = "/spot-order/cancel-by-type";
    return this.post(url, params);
  }

  getRecentTransactions(params) {
    let url = "/spot-order/orders/transactions/recent";
    return this.get(url, params);
  }

  getOrders(params, currency, status, cancelToken) {
    let url = "/orders/" + currency + "/" + status;
    return this.get(url, params, cancelToken);
  }

  getOrdersPending(params) {
    let url = "/spot-order/pending";
    return new Promise((resolve, reject) => {
      this.get(url, params)
        .then((e) => resolve({ data: { ...e, data: e.data ?? [] } }))
        .catch(reject);
    });
  }

  getOrderBook(params) {
    let url = "/spot-order/order-book";
    return new Promise((resolve, reject) => {
      this.get(url, params)
        .then((e) => {
          e.buy = e.bids ?? [];
          e.sell = e.asks ?? [];
          delete e.bids;
          delete e.asks;
          resolve({ data: e });
        })
        .catch(reject);
    });
  }

  getTransactionsFee(params) {
    let url = "/spot-order/market_fee";
    return this.get(url, params);
  }

  getUserOrderBook(params, cancelToken) {
    let url = "/orders/user-order-book";
    return this.get(url, params, cancelToken);
  }

  getUserTransactions(params) {
    let url = "/orders/user-transactions";
    return this.get(url, params);
  }

  getOrderHistory(params) {
    let url = "/spot-order/transactions";
    return new Promise((resolve, reject) => {
      this.get(url, params)
        .then((e) => resolve({ data: { ...e, data: e.data ?? [] } }))
        .catch(reject);
    });
  }

  getTradeHistory(params) {
    let url = "/spot-order/trading-histories";
    return new Promise((resolve, reject) => {
      this.get(url, params)
        .then((e) => resolve({ data: { ...e, data: e.data ?? [] } }))
        .catch(reject);
    });
  }

  downloadTradeHistory(params, fileName) {
    const url = "/orders/trade-history/export";
    this.download(url, params, fileName);
  }

  downloadTransactions(params, fileName) {
    const url = "/orders/transactions/export";
    this.download(url, params, fileName);
  }

  getOrderDetail(id) {
    let url = "/orders/detail/" + id;
    return this.get(url);
  }

  convertOrder(params) {
    let url = "/spot-order";
    return this.post(url, params);
  }

  createNewOrder(data) {
    let url = "/spot-order";
    data.tradeType = data.trade_type;
    return this.post(url, data);
  }
}
